import $ from "jquery";

export const init = () => {
  let $header = $(".header");
  let headerHeight = $header.outerHeight();
  let prevScreenWidth = window.innerWidth;
  let scrollStart = $(".banner") ? headerHeight : 7;

  // On page load with offset
  if (window.scrollY > headerHeight || window.pageYOffset > headerHeight) {
    $header.addClass("header--mini");
  }

  let attempts = 0;
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      // Resize
      $(window).on("resize", function (e) {
        if (!e.isTrigger) {
          clearTimeout(this._timer);
          this._timer = setTimeout(function () {
            // Prevent from further operations for Google mobile browsers
            // (if event is not real screen change of a device)
            if (Math.abs(window.innerWidth - prevScreenWidth) < 149) return;
            prevScreenWidth = window.innerWidth;
            headerHeight = $header.offsetHeight;
          }, 400);
        }
      });

      // Search handler for mobile screens
      // Search field with submit button are fading up when user clicks on a round search button
      $header.find('[data-js="open-search"]').on("click", function (e) {
        let $searchForm = $(".form.form-header-search");
        if ($searchForm.hasClass("active")) {
          $searchForm.slideUp().removeClass("active");
        } else {
          $searchForm.slideDown().addClass("active");
        }
        // if (prevScreenWidth > 767) return;
        // e.preventDefault();
        // let form = $(this).closest("form");
        // form.toggleClass("active");
        // form.prev().toggleClass("fade-out");
      });

      $header
        .find(".form.form-header-search .btn--close")
        .on("click", function (e) {
          $(".form.form-header-search").slideUp().removeClass("active");
        });

      // Search focusin handler (tablets and desktops)
      // Search field becomes wider on focus event and search button is within search box
      // $header.find(".form-header-search input").on("focusin", function (e) {
      //   if (prevScreenWidth < 768) return;
      //   e.preventDefault();
      //   let form = $(this).closest("form");
      //   if (form.hasClass("active")) return;
      //   form.addClass("active");
      //   form.prev().addClass("fade-out");
      // });

      // Mobile search focusout handler (tablets and desktops)
      // $header.find(".form-header-search input").on("focusout", function (e) {
      //   if (prevScreenWidth < 768) return;
      //   e.preventDefault();
      //   let form = $(this).closest("form");
      //   if (!form.hasClass("active")) return;
      //   form.removeClass("active");
      //   form.prev().removeClass("fade-out");
      // });

      /*
      if (document.querySelector('section [data-js="main-text-more"]')) {
        let $textHidden = $('section [data-js="main-text-more"]');
        let $btnReadMore = $textHidden
          .closest("section")
          .find('[data-js="toggle-main-text"]');
        $btnReadMore.on("click", function () {
          $textHidden.toggleClass("d-none");
          if ($btnReadMore.hasClass("btn--read-more")) {
            $btnReadMore
              .removeClass("btn--read-more")
              .addClass("btn--read-less");
          } else {
            $btnReadMore
              .removeClass("btn--read-less")
              .addClass("btn--read-more");
          }
        });
      }
*/

      $(window).on("scroll", function (e) {
        let sc = window.scrollY || window.pageYOffset;
        if (sc > scrollStart) {
          if (!$header.hasClass("header--mini"))
            $header.addClass("header--mini");
        } else {
          if ($header.hasClass("header--mini"))
            $header.removeClass("header--mini");
        }
      });
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
